import { AppContextProvider } from "@/contexts";
import { ProductCart } from "../../organisms";
import * as S from "./styles";

const Cart: React.FC = () => {
  return (
    <AppContextProvider>
      <S.CartPage>
        <ProductCart />
      </S.CartPage>
    </AppContextProvider>
  );
};

export default Cart; 